import PropTypes from "prop-types"

import { IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

const Price = ({ item, type = "product" }) => {
  const onSale =
    type === "product"
      ? item.on_sale
      : item.retail_price > 0 &&
        item.price > 0 &&
        item.retail_price > item.price

  const itemCode = type === "product" ? item.style_code : item.addon_code
  const base_price = item.regular_price || item.retail_price
  return IS_JEWLR() ? (
    <div className="body-lg mb-8 flex items-center gap-8 font-semibold">
      <p
        className={cn(onSale ? "text-ruby" : "text-black")}
        data-cy={`cart-line-item-price-${itemCode}`}
        {...(type === "product"
          ? { "data-ge-basket-productsaleprice": true }
          : {})}
      >
        {to_currency(item.price)}
      </p>
      {onSale && (
        <>
          <p
            className="text-grey-400"
            {...(type === "product"
              ? { "data-ge-basket-productlistprice": true }
              : {})}
          >
            <strike>{to_currency(base_price)}</strike>
            {/* <>RETAIL {to_currency(item.retail_price)}</> */}
          </p>
          {base_price > item.price && (
            <div className="bg-ruby text-12 leading-12 px-8 py-4 font-semibold text-white">
              SAVE {(((base_price - item.price) * 100) / base_price).toFixed(0)}
              %
            </div>
          )}
        </>
      )}
    </div>
  ) : (
    <p
      className={cn(
        "body-lg mb-8 font-semibold",
        onSale ? "text-sale" : "text-black"
      )}
      data-cy={`cart-line-item-price-${item.style_code}`}
    >
      {to_currency(item.price)}
    </p>
  )
}

Price.propTypes = {
  dataCyType: PropTypes.string,
  item: PropTypes.object,
  type: PropTypes.string,
}

export default Price
